// Performance monitoring and web vitals
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

function getConnectionSpeed() {
  return navigator.connection?.effectiveType || 'unknown';
}

function sendToAnalytics(metric, options) {
  const { id, name, value, rating } = metric;
  
  // Log to console for monitoring
  console.log(`[Web Vitals] ${name}: ${value} (${rating})`);
  
  // Store in localStorage for local analytics (optional)
  try {
    const vitalsData = JSON.parse(localStorage.getItem('webVitals') || '[]');
    vitalsData.push({
      id,
      name,
      value,
      rating,
      timestamp: new Date().toISOString(),
      page: window.location.pathname,
      href: window.location.href,
      speed: getConnectionSpeed(),
      ...options
    });
    
    // Keep only last 100 entries
    if (vitalsData.length > 100) {
      vitalsData.splice(0, vitalsData.length - 100);
    }
    
    localStorage.setItem('webVitals', JSON.stringify(vitalsData));
  } catch (error) {
    console.warn('Failed to store web vitals data:', error);
  }
}

// Initialize web vitals monitoring
export function initWebVitals() {
  getCLS(sendToAnalytics);
  getFID(sendToAnalytics);
  getFCP(sendToAnalytics);
  getLCP(sendToAnalytics);
  getTTFB(sendToAnalytics);
}

// Custom performance marks for SEO-specific metrics
export function markSEOMetrics() {
  // Mark when structured data is added
  if (document.querySelector('script[type="application/ld+json"]')) {
    performance.mark('structured-data-ready');
  }
  
  // Mark when meta tags are updated
  if (document.querySelector('meta[property="og:title"]')) {
    performance.mark('meta-tags-ready');
  }
  
  // Mark when lazy loading is complete
  const lazyElements = document.querySelectorAll('[loading="lazy"]');
  if (lazyElements.length > 0) {
    performance.mark('lazy-loading-setup');
  }
}

export default initWebVitals;
